export default function IconSparkle({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M20.87 12.69a1 1 0 0 0 0-2c-6.18-.14-9-3-9-9a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 6.05-2.89 8.91-9 9a1 1 0 0 0 0 2c6.06 0 8.91 2.86 9 9a1 1 0 0 0 1 1 1 1 0 0 0 1-1c.31-6.17 3.15-9 8.94-9Zm-3.98-8.88h1.25v1.25a.75.75 0 0 0 1.5 0V3.81h1.25a.75.75 0 0 0 0-1.5h-1.25V1.06a.75.75 0 1 0-1.5 0v1.25h-1.25a.75.75 0 0 0 0 1.5m6.23 16.38h-1.25v-1.25a.75.75 0 0 0-1.5 0v1.25h-1.25a.75.75 0 0 0 0 1.5h1.25v1.25a.75.75 0 0 0 1.5 0v-1.25h1.25a.75.75 0 0 0 0-1.5"
      />
    </svg>
  )
}
